"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesToI18nEntry = void 0;
var properties_1 = require("./properties");
Object.defineProperty(exports, "propertiesToI18nEntry", { enumerable: true, get: function () { return properties_1.propertiesToI18nEntry; } });
//# sourceMappingURL=index.js.map